import { useRouter } from 'next/router';

import { ProgressBar } from '@tgg/ui';

import { JoinJourneyProgressBarProperties } from './JoinJourneyProgressBar.types';

const joinJourneySteps = [
    {
        label: 'The Gym',
        icon: 'myGym',
        routes: ['/join-now/find-your-gym'],
    } as const,
    {
        label: 'Membership',
        icon: 'memberships',
        routes: [
            '/join-now/choose-membership',
            '/join-now/extras',
            '/join-now/your-membership',
            '/join-now/add-ons',
        ],
    } as const,
    {
        label: 'About You',
        icon: 'account',
        routes: ['/join-now/about-you', '/join-now/email'],
    } as const,
    {
        label: 'Payment',
        icon: 'payment',
        routes: ['/join-now/monthly-payments', '/join-now/your-payments'],
    } as const,
];

const rejoinJourneySteps = [
    {
        label: 'Membership',
        icon: 'memberships',
        routes: [
            '/rejoin-now/your-membership',
            '/rejoin-now/choose-membership',
        ],
    } as const,
    {
        label: 'About You',
        icon: 'account',
        routes: ['/rejoin-now/contact-details', '/rejoin-now/about-you'],
    } as const,
    {
        label: 'Payment',
        icon: 'payment',
        routes: ['/rejoin-now/monthly-payments', '/rejoin-now/today-payments'],
    } as const,
];

export const routeToStepMapping = (steps: any[]) =>
    steps.reduce(
        (
            accumulator: { [x: string]: any },
            joinJourneyStep: {
                routes: string[];
            },
            stepIndex: any,
        ) => {
            joinJourneyStep.routes.forEach((route: string) => {
                accumulator[route] = stepIndex;
            });
            return accumulator;
        },
        {} as { [key: string]: number },
    );

export function JoinJourneyProgressBar({
    isRejoin,
}: JoinJourneyProgressBarProperties) {
    const router = useRouter();
    const mappedRoutes = routeToStepMapping(
        isRejoin ? rejoinJourneySteps : joinJourneySteps,
    );
    const activeStep = mappedRoutes[router.route];

    return (
        <ProgressBar
            steps={isRejoin ? rejoinJourneySteps : joinJourneySteps}
            activeStep={activeStep}
        />
    );
}
